import React from 'react'
import {BsStarFill} from 'react-icons/bs';
import {BsStarHalf} from 'react-icons/bs';

const CompareTable = () => {
  return (
    <div>
        <div>
            <h1 className='text-md font-bold px-2'>Product Details</h1>
        </div>
        <table className="table-auto border-collapse border border-gray-300">
  <tbody>
    <tr className='border border-gray-300 '>
        <td  className='border border-gray-300 p-2 text-sm gray-500 font-bold '>Product</td>
        <td className='border border-gray-300 p-2 text-sm gray-500 font-bold text-rose-500 '>Amazone</td>
        <td className='border border-gray-300 p-2 text-sm gray-500 font-bold text-rose-500'>Fipkart</td>
        <td className='border border-gray-300 p-2 text-sm gray-500 font-bold text-rose-500'>Myntra</td>
    </tr>
    <tr className='border border-gray-300 text-gray-600'>
        <td className='border border-gray-300 p-2 text-sm gray-500 text-black font-bold '>Image</td>
        <td className='border border-gray-300 p-2 text-sm gray-500  '><img src="/images/computer.jfif" className='mx-auto w-24' alt="" /></td>
        <td className='border border-gray-300 p-2 text-sm gray-500 '><img src="/images/computer.jfif" className='mx-auto w-24' alt="" /></td>
        <td className='border border-gray-300 p-2 text-sm gray-500 '><img src="/images/computer.jfif" className='mx-auto w-24' alt="" /></td>
    </tr>

    <tr className='border border-gray-300 text-gray-600'>
        <td className='border border-gray-300 p-2 text-sm gray-500 text-black font-bold '>Price</td>
        <td className='border border-gray-300 p-2 text-sm gray-500 '>$1220.00</td>
        <td className='border border-gray-300 p-2 text-sm gray-500 '>$1220.00</td>
        <td className='border border-gray-300 p-2 text-sm gray-500 '>$1220.00</td>
    </tr>

    <tr className='border border-gray-300 text-gray-600'>
        <td className='border border-gray-300 p-2 text-sm gray-500 text-black font-bold '>Model</td>
        <td className='border border-gray-300 p-2 text-sm gray-500 '>Product 21</td>
        <td className='border border-gray-300 p-2 text-sm gray-500 '>Product 16</td>
        <td className='border border-gray-300 p-2 text-sm gray-500 '>Product 18</td>
    </tr >

    <tr className='border border-gray-300 text-gray-600'>
        <td className='border border-gray-300 p-2 text-sm gray-500 text-black font-bold '>Brand</td>
        <td className='border border-gray-300 p-2 text-sm gray-500 '>Hewlet Packard</td>
        <td className='border border-gray-300 p-2 text-sm gray-500 '>Hewlet Packard</td>
        <td className='border border-gray-300 p-2 text-sm gray-500 '>Hewlet Packard</td>
    </tr>
    <tr className='border border-gray-300 text-gray-600'>
        <td className='border border-gray-300 p-2 text-sm gray-500 text-black font-bold '>Availability</td>
        <td className='border border-gray-300 p-2 text-sm gray-500 '>In stock</td>
        <td className='border border-gray-300 p-2 text-sm gray-500 '>Out of stock</td>
        <td className='border border-gray-300 p-2 text-sm gray-500 '>Out of stock</td>
    </tr>

    <tr className='border border-gray-300 text-gray-600'>
        <td className='border border-gray-300 p-2 text-sm gray-500 text-black font-bold '>Rating</td>
        <td className='border border-gray-300 p-2 text-sm gray-500 '><div className='w-full flex text-yellow-500'><BsStarFill/> <BsStarFill/> <BsStarFill/> <BsStarFill/> <BsStarFill/> </div>
           Based on 12 reviews
        </td>
        <td className='border border-gray-300 p-2 text-sm gray-500 '><div className='w-full flex text-yellow-500'><BsStarFill/> <BsStarFill/> <BsStarFill/> <BsStarFill/> <BsStarFill/> </div>
           Based on 12 reviews
        </td>
        <td className='border border-gray-300 p-2 text-sm gray-500 '><div className='w-full flex text-yellow-500'><BsStarFill/> <BsStarFill/> <BsStarFill/> <BsStarFill/> <BsStarFill/> </div>
           Based on 12 reviews
        </td>
    </tr>

    <tr className='border border-gray-300 text-gray-600'>
        <td className='border border-gray-300 p-2 text-sm gray-500  text-black font-bold '>Summery</td>
        <td className='border border-gray-300 p-2 text-sm gray-500 '>Lorem ipsum dolor sit amet consectetur adipisicing elit. Quisquam numquam obcaecati, pariatur dolorum vitae nisi, magnam optio eveniet autem iste omnis dignissimos quasi laborum cupiditate maxime cum, harum porro temporibus ipsa molestias.</td>
        <td className='border border-gray-300 p-2 text-sm gray-500 '>Lorem ipsum dolor sit amet consectetur adipisicing elit. Quisquam numquam obcaecati, pariatur dolorum vitae nisi, magnam optio eveniet autem iste omnis dignissimos quasi laborum cupiditate maxime cum, harum porro temporibus ipsa molestias.</td>
        <td className='border border-gray-300 p-2 text-sm gray-500 '>Lorem ipsum dolor sit amet consectetur adipisicing elit. Quisquam numquam obcaecati, pariatur dolorum vitae nisi, magnam optio eveniet autem iste omnis dignissimos quasi laborum cupiditate maxime cum, harum porro temporibus ipsa molestias.</td>
    </tr>

    <tr className='border border-gray-300 text-gray-600'>
        <td className='border border-gray-300 p-2 text-sm gray-500 text-black font-bold '>Weight</td>
        <td className='border border-gray-300 p-2 text-sm gray-500 '>1.00 kg</td>
        <td className='border border-gray-300 p-2 text-sm gray-500 '>1.00 kg</td>
        <td className='border border-gray-300 p-2 text-sm gray-500 '>1.00 kg</td>
    </tr>
  </tbody>
</table>
    </div>
  )
}

export default CompareTable